import { useEffect, useState } from 'preact/hooks';
import { toast } from '../ui/ui-store.ts';

/**
 * Chrome's "add to home screen" prompt, deferred until the user asks for it.
 * Same flow as the original app, minus the global variable.
 */
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function InstallBanner() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setDeferred(e as BeforeInstallPromptEvent);
    };
    const onInstalled = () => {
      setDeferred(null);
      toast('JDC Anso est installé sur la tablette');
    };

    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (!deferred) return null;

  return (
    <div class="installBanner">
      <b>📱 Installer JDC Anso</b>
      <div class="small muted">Ajoute le journal de classe à l’écran d’accueil de ta tablette.</div>
      <div class="row">
        <button
          class="btn primary"
          onClick={async () => {
            await deferred.prompt();
            await deferred.userChoice;
            setDeferred(null);
          }}
        >
          Installer
        </button>
        <button class="btn" onClick={() => setDeferred(null)}>
          Plus tard
        </button>
      </div>
    </div>
  );
}
